import { Component } from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";

@Component({
    selector: "packbo-loading",
    templateUrl: "./loading.template.html",
    styleUrls: ["./loading.style.css"],
    imports: [SvgIconComponent]
})
export class LoadingComponent {}
